export const PATH_ID = 'id';
export const ITEM_ID = 'id';
export const PATH_MODIFIED_DATE = 'modifiedDate';
export const ITEM_MODIFIED_DATE = 'modifiedDate';
export const PATH_KOLLEKTIV = 'kollektiv';
export const ITEM_KOLLEKTIV = 'kollektiv';
export const PATH_VERTRAGS_AENDERUNG = 'vertragsAenderung';
export const ITEM_VERTRAGS_AENDERUNG = 'vertragsAenderung';
export const PATH_VERTRAGSZUSTAND_PER_DATUM = 'vertragszustandPerDatum';
export const ITEM_VERTRAGSZUSTAND_PER_DATUM = 'vertragszustandPerDatum';
export const PATH_VERTRAGS_AENDERUNG_INITIALISIERT = 'vertragsAenderungInitialisiert';
export const ITEM_VERTRAGS_AENDERUNG_INITIALISIERT = 'vertragsAenderungInitialisiert';
export const PATH_IDD_BERATUNG_DURCHGEFUEHRT = 'iddBeratungDurchgefuehrt';
export const ITEM_IDD_BERATUNG_DURCHGEFUEHRT = 'iddBeratungDurchgefuehrt';
export const PATH_VERTRAGS_NUMMER = 'vertragsNummer';
export const ITEM_VERTRAGS_NUMMER = 'vertragsNummer';
export const PATH_VERSIONS_NUMMER = 'versionsNummer';
export const ITEM_VERSIONS_NUMMER = 'versionsNummer';
export const PATH_VERTRAG_JAHRES_NETTO_PRAEMIE = 'vertragJahresNettoPraemie';
export const ITEM_VERTRAG_JAHRES_NETTO_PRAEMIE = 'vertragJahresNettoPraemie';
export const PATH_VERTRAGS_ABLAUF_DATUM = 'vertragsAblaufDatum';
export const ITEM_VERTRAGS_ABLAUF_DATUM = 'vertragsAblaufDatum';
export const PATH_VERTRAGS_AENDERUNGS_DATUM = 'vertragsAenderungsDatum';
export const ITEM_VERTRAGS_AENDERUNGS_DATUM = 'vertragsAenderungsDatum';
export const PATH_VERTRAG_BISHERIGER_VN = 'vertragBisherigerVn';
export const ITEM_VERTRAG_BISHERIGER_VN = 'vertragBisherigerVn';
export const PATH_VERTRAG_BISHERIGER_VN_PARTNER_NR = 'vertragBisherigerVn.partnerNr';
export const ITEM_VERTRAG_BISHERIGER_VN_PARTNER_NR = 'partnerNr';
export const PATH_VERTRAG_BISHERIGER_VN_GESCHLECHT = 'vertragBisherigerVn.geschlecht';
export const ITEM_VERTRAG_BISHERIGER_VN_GESCHLECHT = 'geschlecht';
export const PATH_VERTRAG_BISHERIGER_VN_VORNAME = 'vertragBisherigerVn.vorname';
export const ITEM_VERTRAG_BISHERIGER_VN_VORNAME = 'vorname';
export const PATH_VERTRAG_BISHERIGER_VN_TITEL = 'vertragBisherigerVn.titel';
export const ITEM_VERTRAG_BISHERIGER_VN_TITEL = 'titel';
export const PATH_VERTRAG_BISHERIGER_VN_TITEL_NACHGESTELLT = 'vertragBisherigerVn.titelNachgestellt';
export const ITEM_VERTRAG_BISHERIGER_VN_TITEL_NACHGESTELLT = 'titelNachgestellt';
export const PATH_VERTRAG_BISHERIGER_VN_BERUFSTITEL = 'vertragBisherigerVn.berufstitel';
export const ITEM_VERTRAG_BISHERIGER_VN_BERUFSTITEL = 'berufstitel';
export const PATH_VERTRAG_BISHERIGER_VN_TIME_STAMP = 'vertragBisherigerVn.timeStamp';
export const ITEM_VERTRAG_BISHERIGER_VN_TIME_STAMP = 'timeStamp';
export const PATH_VERTRAG_BISHERIGER_VN_NAME = 'vertragBisherigerVn.name';
export const ITEM_VERTRAG_BISHERIGER_VN_NAME = 'name';
export const PATH_VERTRAG_BISHERIGER_VN_GEBDATUM = 'vertragBisherigerVn.gebdatum';
export const ITEM_VERTRAG_BISHERIGER_VN_GEBDATUM = 'gebdatum';
export const PATH_VERTRAG_BISHERIGER_VN_FAMILIENSTAND = 'vertragBisherigerVn.familienstand';
export const ITEM_VERTRAG_BISHERIGER_VN_FAMILIENSTAND = 'familienstand';
export const PATH_VERTRAG_BISHERIGER_VN_BERUFSBEZEICHNUNG = 'vertragBisherigerVn.berufsbezeichnung';
export const ITEM_VERTRAG_BISHERIGER_VN_BERUFSBEZEICHNUNG = 'berufsbezeichnung';
export const PATH_VERTRAG_BISHERIGER_VN_BESCHAEFTIGUNGSART = 'vertragBisherigerVn.beschaeftigungsart';
export const ITEM_VERTRAG_BISHERIGER_VN_BESCHAEFTIGUNGSART = 'beschaeftigungsart';
export const PATH_VERTRAG_BISHERIGER_VN_BESCHAEFTIGT_BEI = 'vertragBisherigerVn.beschaeftigtBei';
export const ITEM_VERTRAG_BISHERIGER_VN_BESCHAEFTIGT_BEI = 'beschaeftigtBei';
export const PATH_VERTRAG_BISHERIGER_VN_GEBURTSLAND = 'vertragBisherigerVn.geburtsland';
export const ITEM_VERTRAG_BISHERIGER_VN_GEBURTSLAND = 'geburtsland';
export const PATH_VERTRAG_BISHERIGER_VN_NATIONALITAET = 'vertragBisherigerVn.nationalitaet';
export const ITEM_VERTRAG_BISHERIGER_VN_NATIONALITAET = 'nationalitaet';
export const PATH_VERTRAG_BISHERIGER_VN_JURISTISCHE_PERSON = 'vertragBisherigerVn.juristischePerson';
export const ITEM_VERTRAG_BISHERIGER_VN_JURISTISCHE_PERSON = 'juristischePerson';
export const PATH_VERTRAG_BISHERIGER_VN_SOZVERSANSTALT = 'vertragBisherigerVn.sozversanstalt';
export const ITEM_VERTRAG_BISHERIGER_VN_SOZVERSANSTALT = 'sozversanstalt';
export const PATH_VERTRAG_BISHERIGER_VN_MERKUR_EMPLOYEE = 'vertragBisherigerVn.merkurEmployee';
export const ITEM_VERTRAG_BISHERIGER_VN_MERKUR_EMPLOYEE = 'merkurEmployee';
export const PATH_VERTRAG_BISHERIGER_VN_VERSICHERUNGSNUMMER = 'vertragBisherigerVn.versicherungsnummer';
export const ITEM_VERTRAG_BISHERIGER_VN_VERSICHERUNGSNUMMER = 'versicherungsnummer';
export const PATH_VERTRAG_BISHERIGER_VN_ADRESSE = 'vertragBisherigerVn.adresse';
export const ITEM_VERTRAG_BISHERIGER_VN_ADRESSE = 'adresse';
export const PATH_VERTRAG_BISHERIGER_VN_ADRESSE_STRASSE = 'vertragBisherigerVn.adresse.strasse';
export const ITEM_VERTRAG_BISHERIGER_VN_ADRESSE_STRASSE = 'strasse';
export const PATH_VERTRAG_BISHERIGER_VN_ADRESSE_HAUSNR = 'vertragBisherigerVn.adresse.hausnr';
export const ITEM_VERTRAG_BISHERIGER_VN_ADRESSE_HAUSNR = 'hausnr';
export const PATH_VERTRAG_BISHERIGER_VN_ADRESSE_IKZ = 'vertragBisherigerVn.adresse.ikz';
export const ITEM_VERTRAG_BISHERIGER_VN_ADRESSE_IKZ = 'ikz';
export const PATH_VERTRAG_BISHERIGER_VN_ADRESSE_ORT = 'vertragBisherigerVn.adresse.ort';
export const ITEM_VERTRAG_BISHERIGER_VN_ADRESSE_ORT = 'ort';
export const PATH_VERTRAG_BISHERIGER_VN_ADRESSE_PLZ = 'vertragBisherigerVn.adresse.plz';
export const ITEM_VERTRAG_BISHERIGER_VN_ADRESSE_PLZ = 'plz';
export const PATH_VERTRAG_BISHERIGER_VN_SOZVERSANSTALT_NAME = 'vertragBisherigerVn.sozversanstaltName';
export const ITEM_VERTRAG_BISHERIGER_VN_SOZVERSANSTALT_NAME = 'sozversanstaltName';
export const PATH_TARIF = 'tarif';
export const ITEM_TARIF = 'tarif';
export const PATH_TARIF_ZUSATZ_DATEN = 'tarifZusatzDaten';
export const ITEM_TARIF_ZUSATZ_DATEN = 'tarifZusatzDaten';
export const PATH_TARIF_ZUSATZ_DATEN_STORNO_POLIZZE_TEXT = 'tarifZusatzDaten.stornoPolizzeText';
export const ITEM_TARIF_ZUSATZ_DATEN_STORNO_POLIZZE_TEXT = 'stornoPolizzeText';
export const PATH_FZ_KONTO = 'fzKonto';
export const ITEM_FZ_KONTO = 'fzKonto';
export const PATH_FZ_KONTO_KONTO = 'fzKonto.konto';
export const ITEM_FZ_KONTO_KONTO = 'konto';
export const PATH_FZ_KONTO_KONTO_NAME = 'fzKonto.kontoName';
export const ITEM_FZ_KONTO_KONTO_NAME = 'kontoName';
export const PATH_FZ_KONTO_EXKLUSIV_ABBER_NR = 'fzKonto.exklusivAbberNr';
export const ITEM_FZ_KONTO_EXKLUSIV_ABBER_NR = 'exklusivAbberNr';
export const PATH_FZ_KONTO_VERRECHNUNGSART = 'fzKonto.verrechnungsart';
export const ITEM_FZ_KONTO_VERRECHNUNGSART = 'verrechnungsart';
export const PATH_FZ_KONTO_BEZEICHNUNG = 'fzKonto.bezeichnung';
export const ITEM_FZ_KONTO_BEZEICHNUNG = 'bezeichnung';
export const PATH_FZ_KONTO_HINWEIS = 'fzKonto.hinweis';
export const ITEM_FZ_KONTO_HINWEIS = 'hinweis';
export const PATH_FZ_KONTO_GILT_VON = 'fzKonto.giltVon';
export const ITEM_FZ_KONTO_GILT_VON = 'giltVon';
export const PATH_FZ_KONTO_GILT_BIS = 'fzKonto.giltBis';
export const ITEM_FZ_KONTO_GILT_BIS = 'giltBis';
export const PATH_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'fzKonto.personalNummerRegex';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER_REGEX = 'personalNummerRegex';
export const PATH_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'fzKonto.personalNummerExplanation';
export const ITEM_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION = 'personalNummerExplanation';
export const PATH_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'fzKonto.dienststelleRequired';
export const ITEM_FZ_KONTO_DIENSTSTELLE_REQUIRED = 'dienststelleRequired';
export const PATH_FZ_KONTO_PERS_NR_ERFORDERLICH = 'fzKonto.persNrErforderlich';
export const ITEM_FZ_KONTO_PERS_NR_ERFORDERLICH = 'persNrErforderlich';
export const PATH_BESTAND_FZ_KONTO_NR = 'bestandFzKontoNr';
export const ITEM_BESTAND_FZ_KONTO_NR = 'bestandFzKontoNr';
export const PATH_UV_VERMITTLER_INFO = 'vermittlerInfo';
export const ITEM_UV_VERMITTLER_INFO = 'vermittlerInfo';
export const PATH_UV_VERMITTLER_INFO_VERMITTLER_NR = 'vermittlerInfo.vermittlerNr';
export const ITEM_UV_VERMITTLER_INFO_VERMITTLER_NR = 'vermittlerNr';
export const PATH_UV_VERMITTLER_INFO_VERMITTLER_NAME = 'vermittlerInfo.vermittlerName';
export const ITEM_UV_VERMITTLER_INFO_VERMITTLER_NAME = 'vermittlerName';
export const PATH_UV_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME = 'vermittlerInfo.vermittlerName.nachname';
export const ITEM_UV_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME = 'nachname';
export const PATH_UV_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME = 'vermittlerInfo.vermittlerName.vorname';
export const ITEM_UV_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME = 'vorname';
export const PATH_UV_VERMITTLER_INFO_MAKLER = 'vermittlerInfo.makler';
export const ITEM_UV_VERMITTLER_INFO_MAKLER = 'makler';
export const PATH_UV_VERMITTLER_INFO_COURTAGE = 'vermittlerInfo.courtage';
export const ITEM_UV_VERMITTLER_INFO_COURTAGE = 'courtage';
export const PATH_UV_VERMITTLER_INFO_HAS_GV = 'vermittlerInfo.hasGv';
export const ITEM_UV_VERMITTLER_INFO_HAS_GV = 'hasGv';
export const PATH_UV_VERMITTLER_INFO_HAS_LV = 'vermittlerInfo.hasLv';
export const ITEM_UV_VERMITTLER_INFO_HAS_LV = 'hasLv';
export const PATH_UV_VERMITTLER_INFO_HAS_SV = 'vermittlerInfo.hasSv';
export const ITEM_UV_VERMITTLER_INFO_HAS_SV = 'hasSv';
export const PATH_UV_VERMITTLER_INFO_HAS_UV = 'vermittlerInfo.hasUv';
export const ITEM_UV_VERMITTLER_INFO_HAS_UV = 'hasUv';
export const PATH_UV_VERMITTLER_INFO_VSE_REQUIRED = 'vermittlerInfo.vseRequired';
export const ITEM_UV_VERMITTLER_INFO_VSE_REQUIRED = 'vseRequired';
export const PATH_UV_VERMITTLER_INFO_KOOPERATIONSPARTNER = 'vermittlerInfo.kooperationspartner';
export const ITEM_UV_VERMITTLER_INFO_KOOPERATIONSPARTNER = 'kooperationspartner';
export const PATH_UV_VERMITTLER_INFO_ABKOMMEN = 'vermittlerInfo.abkommen';
export const ITEM_UV_VERMITTLER_INFO_ABKOMMEN = 'abkommen';
export const PATH_UV_VERMITTLER_INFO_ABBER_TYPE = 'vermittlerInfo.abberType';
export const ITEM_UV_VERMITTLER_INFO_ABBER_TYPE = 'abberType';
export const PATH_UV_VERMITTLER_INFO_IS_MAKLERSPITZE = 'vermittlerInfo.isMaklerspitze';
export const ITEM_UV_VERMITTLER_INFO_IS_MAKLERSPITZE = 'isMaklerspitze';
export const PATH_UV_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE = 'vermittlerInfo.isTeamPartnerSpitze';
export const ITEM_UV_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE = 'isTeamPartnerSpitze';
export const PATH_UV_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES = 'vermittlerInfo.hasDisplayableSubordinates';
export const ITEM_UV_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES = 'hasDisplayableSubordinates';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER = 'vermittlerInfoBlattAbber';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER = 'vermittlerInfoBlattAbber';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR = 'vermittlerInfoBlattAbber.vermittlerNr';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR = 'vermittlerNr';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME = 'vermittlerInfoBlattAbber.vermittlerName';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME = 'vermittlerName';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME =
  'vermittlerInfoBlattAbber.vermittlerName.nachname';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME = 'nachname';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME =
  'vermittlerInfoBlattAbber.vermittlerName.vorname';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME = 'vorname';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_MAKLER = 'vermittlerInfoBlattAbber.makler';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_MAKLER = 'makler';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_COURTAGE = 'vermittlerInfoBlattAbber.courtage';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_COURTAGE = 'courtage';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_GV = 'vermittlerInfoBlattAbber.hasGv';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_GV = 'hasGv';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_LV = 'vermittlerInfoBlattAbber.hasLv';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_LV = 'hasLv';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_SV = 'vermittlerInfoBlattAbber.hasSv';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_SV = 'hasSv';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_UV = 'vermittlerInfoBlattAbber.hasUv';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_UV = 'hasUv';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED = 'vermittlerInfoBlattAbber.vseRequired';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED = 'vseRequired';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER = 'vermittlerInfoBlattAbber.kooperationspartner';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER = 'kooperationspartner';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN = 'vermittlerInfoBlattAbber.abkommen';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN = 'abkommen';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE = 'vermittlerInfoBlattAbber.abberType';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE = 'abberType';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE = 'vermittlerInfoBlattAbber.isMaklerspitze';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE = 'isMaklerspitze';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE =
  'vermittlerInfoBlattAbber.isTeamPartnerSpitze';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE = 'isTeamPartnerSpitze';
export const PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES =
  'vermittlerInfoBlattAbber.hasDisplayableSubordinates';
export const ITEM_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES = 'hasDisplayableSubordinates';
export const PATH_UV_VERTRAGSDATEN = 'uvVertragsdaten';
export const ITEM_UV_VERTRAGSDATEN = 'uvVertragsdaten';
export const PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN = 'uvVertragsdaten.leistungsarten';
export const ITEM_UV_VERTRAGSDATEN_LEISTUNGSARTEN = 'leistungsarten';
export const PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_ID = 'uvVertragsdaten.leistungsarten.id';
export const ITEM_UV_VERTRAGSDATEN_LEISTUNGSARTEN_ID = 'id';
export const PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_VAR = 'uvVertragsdaten.leistungsarten.var';
export const ITEM_UV_VERTRAGSDATEN_LEISTUNGSARTEN_VAR = 'var';
export const PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_KAR = 'uvVertragsdaten.leistungsarten.kar';
export const ITEM_UV_VERTRAGSDATEN_LEISTUNGSARTEN_KAR = 'kar';
export const PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_PNR = 'uvVertragsdaten.leistungsarten.pnr';
export const ITEM_UV_VERTRAGSDATEN_LEISTUNGSARTEN_PNR = 'pnr';
export const PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_VS = 'uvVertragsdaten.leistungsarten.vs';
export const ITEM_UV_VERTRAGSDATEN_LEISTUNGSARTEN_VS = 'vs';
export const PATH_BERATUNGSDATEN = 'beratungsdaten';
export const ITEM_BERATUNGSDATEN = 'beratungsdaten';
export const PATH_BERATUNGSDATEN_TARIF_NR = 'beratungsdaten.tarifNr';
export const ITEM_BERATUNGSDATEN_TARIF_NR = 'tarifNr';
export const PATH_BERATUNGSDATEN_LEISTUNGSARTEN = 'beratungsdaten.leistungsarten';
export const ITEM_BERATUNGSDATEN_LEISTUNGSARTEN = 'leistungsarten';
export const PATH_BERATUNGSDATEN_LEISTUNGSARTEN_ID = 'beratungsdaten.leistungsarten.id';
export const ITEM_BERATUNGSDATEN_LEISTUNGSARTEN_ID = 'id';
export const PATH_BERATUNGSDATEN_LEISTUNGSARTEN_VAR = 'beratungsdaten.leistungsarten.var';
export const ITEM_BERATUNGSDATEN_LEISTUNGSARTEN_VAR = 'var';
export const PATH_BERATUNGSDATEN_LEISTUNGSARTEN_KAR = 'beratungsdaten.leistungsarten.kar';
export const ITEM_BERATUNGSDATEN_LEISTUNGSARTEN_KAR = 'kar';
export const PATH_BERATUNGSDATEN_LEISTUNGSARTEN_PNR = 'beratungsdaten.leistungsarten.pnr';
export const ITEM_BERATUNGSDATEN_LEISTUNGSARTEN_PNR = 'pnr';
export const PATH_UV_PERSONEN_DATA = 'uvPersonenData';
export const ITEM_UV_PERSONEN_DATA = 'uvPersonenData';
export const PATH_UV_PERSONEN_DATA_PERSONEN = 'uvPersonenData.personen';
export const ITEM_UV_PERSONEN_DATA_PERSONEN = 'personen';
export const PATH_UV_PERSONEN_DATA_PERSONEN_ID = 'uvPersonenData.personen.id';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_ID = 'id';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'uvPersonenData.personen.stammdaten';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN = 'stammdaten';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'uvPersonenData.personen.stammdaten.partnerNr';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR = 'partnerNr';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'uvPersonenData.personen.stammdaten.geschlecht';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT = 'geschlecht';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'uvPersonenData.personen.stammdaten.vorname';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME = 'vorname';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'uvPersonenData.personen.stammdaten.titel';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL = 'titel';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT =
  'uvPersonenData.personen.stammdaten.titelNachgestellt';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT = 'titelNachgestellt';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'uvPersonenData.personen.stammdaten.berufstitel';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL = 'berufstitel';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'uvPersonenData.personen.stammdaten.timeStamp';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP = 'timeStamp';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'uvPersonenData.personen.stammdaten.name';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME = 'name';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'uvPersonenData.personen.stammdaten.gebdatum';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM = 'gebdatum';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND =
  'uvPersonenData.personen.stammdaten.familienstand';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND = 'familienstand';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG =
  'uvPersonenData.personen.stammdaten.berufsbezeichnung';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG = 'berufsbezeichnung';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART =
  'uvPersonenData.personen.stammdaten.beschaeftigungsart';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART = 'beschaeftigungsart';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI =
  'uvPersonenData.personen.stammdaten.beschaeftigtBei';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI = 'beschaeftigtBei';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'uvPersonenData.personen.stammdaten.geburtsland';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND = 'geburtsland';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET =
  'uvPersonenData.personen.stammdaten.nationalitaet';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET = 'nationalitaet';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON =
  'uvPersonenData.personen.stammdaten.juristischePerson';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON = 'juristischePerson';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT =
  'uvPersonenData.personen.stammdaten.sozversanstalt';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT = 'sozversanstalt';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE =
  'uvPersonenData.personen.stammdaten.merkurEmployee';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE = 'merkurEmployee';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER =
  'uvPersonenData.personen.stammdaten.versicherungsnummer';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER = 'versicherungsnummer';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'uvPersonenData.personen.stammdaten.adresse';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE = 'adresse';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE =
  'uvPersonenData.personen.stammdaten.adresse.strasse';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE = 'strasse';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR =
  'uvPersonenData.personen.stammdaten.adresse.hausnr';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR = 'hausnr';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'uvPersonenData.personen.stammdaten.adresse.ikz';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ = 'ikz';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'uvPersonenData.personen.stammdaten.adresse.ort';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT = 'ort';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'uvPersonenData.personen.stammdaten.adresse.plz';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ = 'plz';
export const PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME =
  'uvPersonenData.personen.stammdaten.sozversanstaltName';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME = 'sozversanstaltName';
export const PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'uvPersonenData.personen.personRollen';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN = 'personRollen';
export const PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'uvPersonenData.personen.personRollen.vn';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN = 'vn';
export const PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'uvPersonenData.personen.personRollen.vp';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP = 'vp';
export const PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_KIND = 'uvPersonenData.personen.personRollen.kind';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_KIND = 'kind';
export const PATH_UV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH =
  'uvPersonenData.personen.hauptwohnsitzOesterreich';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH = 'hauptwohnsitzOesterreich';
export const PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN = 'uvPersonenData.personen.personBeziehungen';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN = 'personBeziehungen';
export const PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG =
  'uvPersonenData.personen.personBeziehungen.vnBeziehung';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG = 'vnBeziehung';
export const PATH_UV_PERSONEN_DATA_PERSONEN_KIND_IN_VERTRAG = 'uvPersonenData.personen.kindInVertrag';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_KIND_IN_VERTRAG = 'kindInVertrag';
export const PATH_UV_PERSONEN_DATA_PERSONEN_GESUNDHEITSFRAGEN_NOTWENDIG =
  'uvPersonenData.personen.gesundheitsfragenNotwendig';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_GESUNDHEITSFRAGEN_NOTWENDIG = 'gesundheitsfragenNotwendig';
export const PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE = 'uvPersonenData.personen.berufe';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_BERUFE = 'berufe';
export const PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE_NAME = 'uvPersonenData.personen.berufe.name';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_BERUFE_NAME = 'name';
export const PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE_GEFAHRENKLASSE = 'uvPersonenData.personen.berufe.gefahrenklasse';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_BERUFE_GEFAHRENKLASSE = 'gefahrenklasse';
export const PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE_GESUNDHEITSTARIF = 'uvPersonenData.personen.berufe.gesundheitstarif';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_BERUFE_GESUNDHEITSTARIF = 'gesundheitstarif';
export const PATH_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN = 'uvPersonenData.personen.hobbygruppen';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN = 'hobbygruppen';
export const PATH_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN_VALUE = 'uvPersonenData.personen.hobbygruppen.value';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN_VALUE = 'value';
export const PATH_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN_BEZEICHNUNG =
  'uvPersonenData.personen.hobbygruppen.bezeichnung';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN_BEZEICHNUNG = 'bezeichnung';
export const PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN = 'uvPersonenData.personen.amateursportgruppen';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN = 'amateursportgruppen';
export const PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN_VALUE =
  'uvPersonenData.personen.amateursportgruppen.value';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN_VALUE = 'value';
export const PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN_BEZEICHNUNG =
  'uvPersonenData.personen.amateursportgruppen.bezeichnung';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN_BEZEICHNUNG = 'bezeichnung';
export const PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT = 'uvPersonenData.personen.amateursport';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT = 'amateursport';
export const PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT_VALUE = 'uvPersonenData.personen.amateursport.value';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT_VALUE = 'value';
export const PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT_BEZEICHNUNG =
  'uvPersonenData.personen.amateursport.bezeichnung';
export const ITEM_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT_BEZEICHNUNG = 'bezeichnung';

import { ModelField, ModelGroup, ModelItemAccessor } from '@mng/model';

export class UvAngebotDataItemAccessor {
  constructor(public itemAccessor: ModelItemAccessor) {}

  getId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_ID);
  }
  getModifiedDate(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_MODIFIED_DATE);
  }
  getKollektiv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_KOLLEKTIV);
  }
  getVertragsAenderung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNG);
  }
  getVertragszustandPerDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGSZUSTAND_PER_DATUM);
  }
  getVertragsAenderungInitialisiert(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNG_INITIALISIERT);
  }
  getIddBeratungDurchgefuehrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_IDD_BERATUNG_DURCHGEFUEHRT);
  }
  getVertragsNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_NUMMER);
  }
  getVersionsNummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERSIONS_NUMMER);
  }
  getVertragJahresNettoPraemie(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_JAHRES_NETTO_PRAEMIE);
  }
  getVertragsAblaufDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_ABLAUF_DATUM);
  }
  getVertragsAenderungsDatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAGS_AENDERUNGS_DATUM);
  }
  getVertragBisherigerVn(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN);
  }
  getVertragBisherigerVnPartnerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_PARTNER_NR);
  }
  getVertragBisherigerVnGeschlecht(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_GESCHLECHT);
  }
  getVertragBisherigerVnVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_VORNAME);
  }
  getVertragBisherigerVnTitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_TITEL);
  }
  getVertragBisherigerVnTitelNachgestellt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_TITEL_NACHGESTELLT);
  }
  getVertragBisherigerVnBerufstitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_BERUFSTITEL);
  }
  getVertragBisherigerVnTimeStamp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_TIME_STAMP);
  }
  getVertragBisherigerVnName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_NAME);
  }
  getVertragBisherigerVnGebdatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_GEBDATUM);
  }
  getVertragBisherigerVnFamilienstand(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_FAMILIENSTAND);
  }
  getVertragBisherigerVnBerufsbezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_BERUFSBEZEICHNUNG);
  }
  getVertragBisherigerVnBeschaeftigungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_BESCHAEFTIGUNGSART);
  }
  getVertragBisherigerVnBeschaeftigtBei(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_BESCHAEFTIGT_BEI);
  }
  getVertragBisherigerVnGeburtsland(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_GEBURTSLAND);
  }
  getVertragBisherigerVnNationalitaet(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_NATIONALITAET);
  }
  getVertragBisherigerVnJuristischePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_JURISTISCHE_PERSON);
  }
  getVertragBisherigerVnSozversanstalt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_SOZVERSANSTALT);
  }
  getVertragBisherigerVnMerkurEmployee(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_MERKUR_EMPLOYEE);
  }
  getVertragBisherigerVnVersicherungsnummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_VERSICHERUNGSNUMMER);
  }
  getVertragBisherigerVnAdresse(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_ADRESSE);
  }
  getVertragBisherigerVnAdresseStrasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_ADRESSE_STRASSE);
  }
  getVertragBisherigerVnAdresseHausnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_ADRESSE_HAUSNR);
  }
  getVertragBisherigerVnAdresseIkz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_ADRESSE_IKZ);
  }
  getVertragBisherigerVnAdresseOrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_ADRESSE_ORT);
  }
  getVertragBisherigerVnAdressePlz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_ADRESSE_PLZ);
  }
  getVertragBisherigerVnSozversanstaltName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_VERTRAG_BISHERIGER_VN_SOZVERSANSTALT_NAME);
  }
  getTarif(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_TARIF);
  }
  getTarifZusatzDaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_TARIF_ZUSATZ_DATEN);
  }
  getTarifZusatzDatenStornoPolizzeText(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_TARIF_ZUSATZ_DATEN_STORNO_POLIZZE_TEXT);
  }
  getFzKonto(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_FZ_KONTO);
  }
  getFzKontoKonto(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_KONTO);
  }
  getFzKontoKontoName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_KONTO_NAME);
  }
  getFzKontoExklusivAbberNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_EXKLUSIV_ABBER_NR);
  }
  getFzKontoVerrechnungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_VERRECHNUNGSART);
  }
  getFzKontoBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_BEZEICHNUNG);
  }
  getFzKontoHinweis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_HINWEIS);
  }
  getFzKontoGiltVon(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_GILT_VON);
  }
  getFzKontoGiltBis(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_GILT_BIS);
  }
  getFzKontoPersonalNummerRegex(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER_REGEX);
  }
  getFzKontoPersonalNummerExplanation(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERSONAL_NUMMER_EXPLANATION);
  }
  getFzKontoDienststelleRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_DIENSTSTELLE_REQUIRED);
  }
  getFzKontoPersNrErforderlich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_FZ_KONTO_PERS_NR_ERFORDERLICH);
  }
  getBestandFzKontoNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BESTAND_FZ_KONTO_NR);
  }
  getVermittlerInfo(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO);
  }
  getVermittlerInfoVermittlerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_VERMITTLER_NR);
  }
  getVermittlerInfoVermittlerName(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_VERMITTLER_NAME);
  }
  getVermittlerInfoVermittlerNameNachname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_VERMITTLER_NAME_NACHNAME);
  }
  getVermittlerInfoVermittlerNameVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_VERMITTLER_NAME_VORNAME);
  }
  getVermittlerInfoMakler(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_MAKLER);
  }
  getVermittlerInfoCourtage(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_COURTAGE);
  }
  getVermittlerInfoHasGv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_HAS_GV);
  }
  getVermittlerInfoHasLv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_HAS_LV);
  }
  getVermittlerInfoHasSv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_HAS_SV);
  }
  getVermittlerInfoHasUv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_HAS_UV);
  }
  getVermittlerInfoVseRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_VSE_REQUIRED);
  }
  getVermittlerInfoKooperationspartner(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_KOOPERATIONSPARTNER);
  }
  getVermittlerInfoAbkommen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_ABKOMMEN);
  }
  getVermittlerInfoAbberType(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_ABBER_TYPE);
  }
  getVermittlerInfoIsMaklerspitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_IS_MAKLERSPITZE);
  }
  getVermittlerInfoIsTeamPartnerSpitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_IS_TEAM_PARTNER_SPITZE);
  }
  getVermittlerInfoHasDisplayableSubordinates(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_HAS_DISPLAYABLE_SUBORDINATES);
  }
  getVermittlerInfoBlattAbber(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER);
  }
  getVermittlerInfoBlattAbberVermittlerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NR);
  }
  getVermittlerInfoBlattAbberVermittlerName(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME);
  }
  getVermittlerInfoBlattAbberVermittlerNameNachname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_NACHNAME);
  }
  getVermittlerInfoBlattAbberVermittlerNameVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VERMITTLER_NAME_VORNAME);
  }
  getVermittlerInfoBlattAbberMakler(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_MAKLER);
  }
  getVermittlerInfoBlattAbberCourtage(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_COURTAGE);
  }
  getVermittlerInfoBlattAbberHasGv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_GV);
  }
  getVermittlerInfoBlattAbberHasLv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_LV);
  }
  getVermittlerInfoBlattAbberHasSv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_SV);
  }
  getVermittlerInfoBlattAbberHasUv(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_UV);
  }
  getVermittlerInfoBlattAbberVseRequired(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_VSE_REQUIRED);
  }
  getVermittlerInfoBlattAbberKooperationspartner(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_KOOPERATIONSPARTNER);
  }
  getVermittlerInfoBlattAbberAbkommen(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_ABKOMMEN);
  }
  getVermittlerInfoBlattAbberAbberType(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_ABBER_TYPE);
  }
  getVermittlerInfoBlattAbberIsMaklerspitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_IS_MAKLERSPITZE);
  }
  getVermittlerInfoBlattAbberIsTeamPartnerSpitze(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_IS_TEAM_PARTNER_SPITZE);
  }
  getVermittlerInfoBlattAbberHasDisplayableSubordinates(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERMITTLER_INFO_BLATT_ABBER_HAS_DISPLAYABLE_SUBORDINATES);
  }
  getUvVertragsdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN);
  }
  getUvVertragsdatenLeistungsarten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN);
  }
  getUvVertragsdatenLeistungsartenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_ID);
  }
  getUvVertragsdatenLeistungsartenVar(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_VAR);
  }
  getUvVertragsdatenLeistungsartenKar(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_KAR);
  }
  getUvVertragsdatenLeistungsartenPnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_PNR);
  }
  getUvVertragsdatenLeistungsartenVs(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_VERTRAGSDATEN_LEISTUNGSARTEN_VS);
  }
  getBeratungsdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN);
  }
  getBeratungsdatenTarifNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_TARIF_NR);
  }
  getBeratungsdatenLeistungsarten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_LEISTUNGSARTEN);
  }
  getBeratungsdatenLeistungsartenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_LEISTUNGSARTEN_ID);
  }
  getBeratungsdatenLeistungsartenVar(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_LEISTUNGSARTEN_VAR);
  }
  getBeratungsdatenLeistungsartenKar(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_LEISTUNGSARTEN_KAR);
  }
  getBeratungsdatenLeistungsartenPnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_BERATUNGSDATEN_LEISTUNGSARTEN_PNR);
  }
  getUvPersonenData(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA);
  }
  getUvPersonenDataPersonen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN);
  }
  getUvPersonenDataPersonenId(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_ID);
  }
  getUvPersonenDataPersonenStammdaten(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN);
  }
  getUvPersonenDataPersonenStammdatenPartnerNr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_PARTNER_NR);
  }
  getUvPersonenDataPersonenStammdatenGeschlecht(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GESCHLECHT);
  }
  getUvPersonenDataPersonenStammdatenVorname(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VORNAME);
  }
  getUvPersonenDataPersonenStammdatenTitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL);
  }
  getUvPersonenDataPersonenStammdatenTitelNachgestellt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TITEL_NACHGESTELLT);
  }
  getUvPersonenDataPersonenStammdatenBerufstitel(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSTITEL);
  }
  getUvPersonenDataPersonenStammdatenTimeStamp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_TIME_STAMP);
  }
  getUvPersonenDataPersonenStammdatenName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NAME);
  }
  getUvPersonenDataPersonenStammdatenGebdatum(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBDATUM);
  }
  getUvPersonenDataPersonenStammdatenFamilienstand(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_FAMILIENSTAND);
  }
  getUvPersonenDataPersonenStammdatenBerufsbezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BERUFSBEZEICHNUNG);
  }
  getUvPersonenDataPersonenStammdatenBeschaeftigungsart(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGUNGSART);
  }
  getUvPersonenDataPersonenStammdatenBeschaeftigtBei(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_BESCHAEFTIGT_BEI);
  }
  getUvPersonenDataPersonenStammdatenGeburtsland(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_GEBURTSLAND);
  }
  getUvPersonenDataPersonenStammdatenNationalitaet(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_NATIONALITAET);
  }
  getUvPersonenDataPersonenStammdatenJuristischePerson(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_JURISTISCHE_PERSON);
  }
  getUvPersonenDataPersonenStammdatenSozversanstalt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT);
  }
  getUvPersonenDataPersonenStammdatenMerkurEmployee(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_MERKUR_EMPLOYEE);
  }
  getUvPersonenDataPersonenStammdatenVersicherungsnummer(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_VERSICHERUNGSNUMMER);
  }
  getUvPersonenDataPersonenStammdatenAdresse(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE);
  }
  getUvPersonenDataPersonenStammdatenAdresseStrasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_STRASSE);
  }
  getUvPersonenDataPersonenStammdatenAdresseHausnr(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_HAUSNR);
  }
  getUvPersonenDataPersonenStammdatenAdresseIkz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_IKZ);
  }
  getUvPersonenDataPersonenStammdatenAdresseOrt(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_ORT);
  }
  getUvPersonenDataPersonenStammdatenAdressePlz(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_ADRESSE_PLZ);
  }
  getUvPersonenDataPersonenStammdatenSozversanstaltName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_STAMMDATEN_SOZVERSANSTALT_NAME);
  }
  getUvPersonenDataPersonenPersonRollen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN);
  }
  getUvPersonenDataPersonenPersonRollenVn(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VN);
  }
  getUvPersonenDataPersonenPersonRollenVp(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_VP);
  }
  getUvPersonenDataPersonenPersonRollenKind(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_ROLLEN_KIND);
  }
  getUvPersonenDataPersonenHauptwohnsitzOesterreich(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_HAUPTWOHNSITZ_OESTERREICH);
  }
  getUvPersonenDataPersonenPersonBeziehungen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN);
  }
  getUvPersonenDataPersonenPersonBeziehungenVnBeziehung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_PERSON_BEZIEHUNGEN_VN_BEZIEHUNG);
  }
  getUvPersonenDataPersonenKindInVertrag(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_KIND_IN_VERTRAG);
  }
  getUvPersonenDataPersonenGesundheitsfragenNotwendig(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_GESUNDHEITSFRAGEN_NOTWENDIG);
  }
  getUvPersonenDataPersonenBerufe(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE);
  }
  getUvPersonenDataPersonenBerufeName(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE_NAME);
  }
  getUvPersonenDataPersonenBerufeGefahrenklasse(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE_GEFAHRENKLASSE);
  }
  getUvPersonenDataPersonenBerufeGesundheitstarif(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_BERUFE_GESUNDHEITSTARIF);
  }
  getUvPersonenDataPersonenHobbygruppen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN);
  }
  getUvPersonenDataPersonenHobbygruppenValue(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN_VALUE);
  }
  getUvPersonenDataPersonenHobbygruppenBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_HOBBYGRUPPEN_BEZEICHNUNG);
  }
  getUvPersonenDataPersonenAmateursportgruppen(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN);
  }
  getUvPersonenDataPersonenAmateursportgruppenValue(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN_VALUE);
  }
  getUvPersonenDataPersonenAmateursportgruppenBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORTGRUPPEN_BEZEICHNUNG);
  }
  getUvPersonenDataPersonenAmateursport(): ModelGroup {
    return <ModelGroup>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT);
  }
  getUvPersonenDataPersonenAmateursportValue(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT_VALUE);
  }
  getUvPersonenDataPersonenAmateursportBezeichnung(): ModelField {
    return <ModelField>this.itemAccessor.getModelItem(PATH_UV_PERSONEN_DATA_PERSONEN_AMATEURSPORT_BEZEICHNUNG);
  }
}
